import { ScrollDispatcher } from '@angular/cdk/scrolling';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, merge as observableMerge } from 'rxjs';
import { debounceTime, map, publishReplay, refCount } from 'rxjs/operators';

import {
  RenderEvent,
  SCROLL_THROTTLE_TIME_MS,
  WINDOW_RESIZE_DEBOUNCE_MS,
} from '®shared/render-event';
import { WindowResizeService } from '®shared/window/window-resize.service';

@Injectable()
export class VirtualisationService {
  private forceRerenderSubject = new ReplaySubject<RenderEvent>(1);

  windowResize$ = this.windowResizeService.windowResized().pipe(
    debounceTime(WINDOW_RESIZE_DEBOUNCE_MS),
    map(() => RenderEvent.WINDOW_RESIZE),
  );

  windowScroll$ = this.scrollDispatcher
    .scrolled(SCROLL_THROTTLE_TIME_MS)
    .pipe(map(() => RenderEvent.WINDOW_SCROLL));

  forceRerender$: Observable<RenderEvent> = observableMerge(
    this.forceRerenderSubject.asObservable(),
    this.windowResize$,
    this.windowScroll$,
  ).pipe(publishReplay(1), refCount());

  constructor(
    private scrollDispatcher: ScrollDispatcher,
    private windowResizeService: WindowResizeService,
  ) {}

  /**
   * Call this to force all virtualised components to recheck their
   * on-sreen position - especially useful for filtering which are
   * displayed.
   */
  forceAllVirtualisersToRecheckPosition(): void {
    this.forceRerenderSubject.next(RenderEvent.RE_RENDER);
  }
}
